<template>
  <v-container fluid>
    <BaseTableFiltered
        ref="baseTableRef"
        :title="$t('VariantSolo')"
        :subtractHeight="subtractHeight"
        :height="height"
        dto-model="VariantSoloListQueryDTO"
        dto-save-list-model="VariantSoloSaveListCommandDTO"
        store-name="PVariantSoloTable"
        new-item-component="PVariantSoloItem"
        new-item-pass="/PBatchRun/VariantSolo/PVariantSoloItem"
        :lang-dictionary="function(text) {return $t(text)}"
        fixed-header
        row-statuses="row_statuses"
        show-selected
        :single-select="singleSelect"
        :action-selected="actionSelected"
        :init-search-term="initSearchTerm"
        @choice="$emit('choice', $event)"
        @changeSearchTerm="$emit('changeSearchTerm', $event)"
        @item-selected="$emit('item-selected', $event)"
        :metadata="metadata"
        @click:row="$emit('click:row', $event)"
    >
<!--      <template v-slot:item.title="{ item }">-->
<!--        <router-link :to="{name:'PVariantSoloItem', params: { itemUid: item.uid}}">-->
<!--          <span class="d-flex justify-start">{{ item.title }}</span>-->
<!--        </router-link>-->
<!--      </template>-->
      <template v-slot:item.notion_id="{ item }">
        <BaseNotionLink :value="item.notion_id" small outlined></BaseNotionLink>
      </template>
    </BaseTableFiltered>
    <v-dialog max-width="900" v-model="informationDialog">
      <v-card max-height="600" class="overflow-y-auto">
        {{ information }}
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import BaseImageCard from "@/components/Base/BaseImageCard";
import commonFunction from "@/commonFunction/commonFunction";
import BaseTableFiltered from "@/components/Base/BaseTableFieltered";
import BaseFilterGroupTable from "@/components/Base/BaseFilterGroupTable";
import BaseNotionLink from "@/components/Base/BaseNotionLink";

export default {
  name: 'PVariantSoloTable',
  props: {
    subtractHeight: {type: [Number], default: 140},
    height: {type: [Number], default: window.innerHeight},
    modalDialog: {type: [Boolean], default: false},
    singleSelect: {type: [Boolean], default: false},
    actionSelected: {default: false},
    initSearchTerm: {default: null},
    metadata: {default: null},
  },

  components: {
    BaseImageCard,
    BaseTableFiltered,
    BaseFilterGroupTable,
    BaseNotionLink,
  },

  computed: {
    ...commonFunction.mapStoreFields([]),
  },

  methods: {
    exportAction(instance) {
      let selected_uid_list = []
      instance.selectedItemList.forEach(row => selected_uid_list.push(row.uid))
      let dto_search = {
        current_uid: null,
        selected_uid_list: selected_uid_list,
      }
      instance.fetchAction({dto: dto_search, dto_action_model: this.dto_export_model})
    },

  },

  async mounted() {
    // console.log('mounted')
  },

  created() {
  },

  destroyed() {
  },

  beforeCreate() {
  },

  beforeDestroy() {
  },

  data() {
    return {
      informationDialog: false,
      information: null,
    }
  }
}
</script>

<style>
.row_even {
}
</style>


<i18n src="@/components/PBatchRun/locales.json">
</i18n>
